"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DevelopmentInfoScript = void 0;
var _react = require("react");
var _internals = require("../internals");
/**
 * Provides various insights about the project, such as the build date, last commit message and author etc.
 * You should be able to view it by opening the console in your browser.
 * Note that the information is always accessible on non-live environments.
 * If you want to view the information on live, you have to provide the `dbg` queryparameter and set it to `true`. For instance: `https://hu.oriflame.com/?dbg=true`.
 */
const DevelopmentInfoScript = ({
  featureToggles,
  info,
  tenant,
  operationId,
  extraInfo
}) => {
  const developmentInfo = (0, _react.useMemo)(() => {
    const obj = {
      ...extraInfo,
      buildMode: info?.buildMode ?? '',
      performanceMetrics: {}
    };
    if (info?.version) {
      obj.version = info.version;
    }
    if (info?.buildId) {
      obj.buildId = info.buildId;
    }
    if (tenant) {
      obj.tenant = tenant;
    }
    if (operationId) {
      obj.operationId = operationId;
    }
    if (info?.environment) {
      obj.environment = info.environment;
    }
    if (info?.serviceName) {
      obj.serviceName = info.serviceName;
    }
    if (featureToggles) {
      obj.featureToggles = featureToggles;
    }
    if (info?.environment !== 'live' && info?.commitAuthor) {
      obj.commitAuthor = info.commitAuthor;
    }
    if (info?.environment !== 'live' && info?.commitMessage) {
      obj.commitMessage = info.commitMessage;
    }
    if (info?.commitDate) {
      obj.commitDate = info.commitDate;
    }
    if (info?.commitHash) {
      obj.commitHash = info.commitHash;
    }
    if (info?.gitBranch) {
      obj.gitBranch = info.gitBranch;
    }
    if (info?.appBuiltAt) {
      obj.appBuiltAt = info.appBuiltAt;
    }
    if (info?.teamName) {
      obj.teamName = info.teamName;
    }
    return obj;
  }, [extraInfo, info, featureToggles, tenant, operationId]);
  (0, _react.useEffect)(() => {
    const hasQueryParam = new URLSearchParams(window.location.search).has('dbg');
    const {
      environment
    } = developmentInfo;
    const shouldShow = environment === 'live' && hasQueryParam || environment !== 'live';
    if (shouldShow) {
      // TODO (OL): we could use logger if it would show info even in production
      // eslint-disable-next-line no-console -- We intentionally want to notify in the console
      console.info('Detailed information about this app can be shown by running script "ori.developmentInfo" in DevTools console.');
      (0, _internals.addDevelopmentInfoToWindow)(developmentInfo);
    }
  }, [developmentInfo]);
  return null;
};
exports.DevelopmentInfoScript = DevelopmentInfoScript;
